module.exports = __webpack_public_path__ + "static/media/sort-amount-down~bgvrcyRP.ab719f38.svg";